import { useLocalization } from "@fluent/react";
import { AttentionRow } from "./AttentionRow";
import styles from "../LoanPortalDashboard.module.css";
import type { LoanPortalApplication } from "../types";

/** The "Things need your attention" card listing needs-attention applications. */
export function AttentionCard({ applications }: { applications: LoanPortalApplication[] }) {
  const { l10n } = useLocalization();

  if (applications.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.attentionCard}
      role="region"
      aria-label={l10n.getString("loan-portal-group-needs-attention", null, "Needs attention")}
    >
      <div className={styles.attentionHeader}>
        <span className={styles.attentionCount}>{applications.length}</span>
        <span className={styles.attentionTitle}>
          {l10n.getString(
            "loan-portal-attention-title",
            { count: applications.length },
            applications.length === 1 ? "Thing needs your attention" : "Things need your attention"
          )}
        </span>
      </div>
      {applications.map((application) => (
        <AttentionRow key={application.uuid} application={application} />
      ))}
    </div>
  );
}
